import { render, staticRenderFns } from "./requisitionfrm.vue?vue&type=template&id=2748ae26"
import script from "./requisitionfrm.vue?vue&type=script&lang=js"
export * from "./requisitionfrm.vue?vue&type=script&lang=js"
import style0 from "./requisitionfrm.vue?vue&type=style&index=0&id=2748ae26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports